import styles from "../../styles/Components/new-dashboard/DashboardPreviewInfo.module.css";

function DashboardPreviewInfo({ children }) {
  return <div className={styles.container}>{children}</div>;
}

export default DashboardPreviewInfo;
